import { render, staticRenderFns } from "./PurchaseCareer.vue?vue&type=template&id=fe6b05ec"
import script from "./PurchaseCareer.vue?vue&type=script&lang=js"
export * from "./PurchaseCareer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports